import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/generated_reports";
export default {
  index(queryString, config = {}) {
    // get the list
    return queryString
        ? Repository.get(`${resource}?${queryString}`, config)
        : Repository.get(`${resource}`, config);
  },
    destroy(id) {
        // delete the item
        return Repository.delete(`${resource}/${id}`);
    },
};
